import { TPickupPointProvider } from 'models/orders'
import { getCdekTrackingUrl } from './getCdekTrackingUrl'

interface DeliveryTrackingInfo {
  tracking?: string
  tracking_url?: string
}

export const getDeliveryTrackingUrl = (
  deliveryInfo?: DeliveryTrackingInfo,
  provider?: TPickupPointProvider
): string | undefined => {
  if (provider === 'YANDEX' && deliveryInfo?.tracking) {
    return `https://dostavka.yandex.ru/ndd/tracking?order_tracking_id=${encodeURIComponent(deliveryInfo.tracking)}`
  }
  if (deliveryInfo?.tracking_url) return deliveryInfo.tracking_url
  if (!deliveryInfo?.tracking) return undefined

  return getCdekTrackingUrl(deliveryInfo.tracking)
}
